import * as yup from 'yup';
import moment from 'moment';

export const validations = yup.object().shape({
  dateStart: yup
    .string()
    .test(function(date) {
      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data inicial é obrigatória',
          path: 'dateStart'
        });
      }

      return true;
    }),
  dateEnd: yup
    .string()
    .test(function(date) {
      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data final é obrigatória',
          path: 'dateEnd'
        });
      }

      return true;
    }),
  timeStart: yup
    .string()
    .required('A hora inicial é obrigatória'),
  timeEnd: yup
    .string()
    .required('A hora final é obrigatória'),
  client: yup.object().shape({
    email: yup
      .string()
      .email('O e-mail precisa ser válido')
      .nullable()
  })
});